<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="msg-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="msg-view">
                        <p v-html="text"></p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="closeModal"></div>
                        <!-- <div class="u-btn cancel" @click="closeModal"></div> -->
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.msg-modal{
    position: relative;
    width: 625px;
    height: 265px;
    font-size: 24px;
    color: #3d3e43;
    background-image: url(~@/assets/images/modal/bg-modal-mgs.png);
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%,-40%);
    /* width: 666px;
    height: 137px;
    margin: 20px auto;
    background-image: url(~@/assets/images/bg-msg.png);
    color: #8e492e; */
}

.msg-view p{
    padding: 0 20px;
    line-height: 1.8;
}

.msg-view b{
    color: #fe5a1e;
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.ok{
    width: 186px;
    height: 56px;
    background-image: url(~@/assets/images/modal/btn-submit.png);    
}


</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },       
    },    
}
</script>